import { render, staticRenderFns } from "./login.pug?vue&type=template&id=0cba0f95&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./login.scss?vue&type=style&index=0&id=0cba0f95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba0f95",
  null
  
)

export default component.exports